import stockCars from '../../api/stockCars'
import apiSearch from "../../api/apiSearch";
import apiAuctions from "../../api/apiAuctions";

const state = {
    lot: '',
    status: false,
    searchResults: [],
    currentPage: null,
    lastPage: null,
    firstPage: 1,
    totalLots: null,
    activeLotKey: null,
    isLoading: false,
    isVisited: [],
    query: {
        order_column: 'auct_date',
        order_type: 'DESC',
        page: 1,
        brand: '',
        'models': [],
        'grades': [],
        yearMin: 0,
        yearMax: new Date().getFullYear(),
        kmsMin: null,
        kmsMax: null,
        priceMin: null,
        priceMax: null,
        ccMin: null,
        ccMax: null,
        date: null,
        'dates': [],
        carGrade: null,
        'chassis': [],
        'transmissions': [],
        'lots': [],
        'colors': [],
        'equipment': [],
        'auctions': [],
        'regions': [],
        limit_start: 0,
        limit_end: 30,
    },
    stockCarAlertModalStatus: false,
    stockCarAlertMessage: null,
    stockCarErrorMessage: null,
    carObj: null,
    models: [],
    types: [],
    serverModels: [],
    chassis: [],
    regions: [],
    auctions: [],
}

const getters = {
    getStockCars: function (state) {
        return state.searchResults
    },
    getStockCarsQuery: function (state) {
        return state.query
    },
    getStockCarsOrderType: function (state) {
        return state.query.order_type
    },
    getStockCarsCurrentPage: function (state) {
        return state.currentPage
    },
    isStockCarsLastPage: function (state) {
        return state.lastPage === state.currentPage
    },
    getStockCarsFirstPage: (state) => {
        return state.firstPage
    },
    getStockCarsLastPage: (state) => {
        return state.lastPage
    },
    getTotalStockCars: function (state) {
        return state.totalLots
    },
    getStockCarsLoadingStatus: (state) => {
        return state.isLoading
    },
    getStockCarAlertModalStatus: (state) => {
        return state.stockCarAlertModalStatus
    },
    getStockCarAlertMessage: (state) => {
        return state.stockCarAlertMessage
    },
    getStockCarErrorMessage: (state) => {
        return state.stockCarErrorMessage
    },
    getStockCarObj: (state) => {
        return state.carObj
    },
    getAuctionSearchQueryStock: (state) => {
        return state.query
    },
    getQueryModelsStock: state => {
        return state.query.models
    },
    getServerModelsStock: (state) => {
        return state.serverModels
    },
    getQueryCompanyIdStock: state => {
        return state.query.brand
    },
    getQueryModelsByModelStock: state => model => {
        return state.query['models'].filter(m => m === model)
    },
    getQueryChassisStock: (state) => {
        return state.query["chassis"]
    },
    getAllChassisStock: (state) => {
        return state.chassis
    },
    getQueryChassisByChassisStock: state => chassis => {
        return state.query['chassis'].filter(m => m === chassis)
    },
    getQueryYearMinStock: (state) => {
        return state.query.yearMin
    },
    getQueryYearMaxStock: (state) => {
        return state.query.yearMax
    },
    getQueryKmMinStock: (state) => {
        return state.query.kmsMin
    },
    getQueryKmMaxStock: (state) => {
        return state.query.kmsMax
    },
    getQueryLotsStock: (state) => {
        return state.query["lots"]
    },
    getStatsStatusStock: (state) => {
        return state.status
    },
    getQueryDatesByDateStock: state => date => {
        return state.query['dates'].filter(m => m === date)
    },
    getSearchResultsLoadingStatusStock: (state) => {
        return state.isLoading
    },
    getRegionsStock: (state) => {
        return state.regions
    },
    getQueryCCMinStock: (state) => {
        return state.query.ccMin
    },
    getQueryCCMaxStock: (state) => {
        return state.query.ccMax
    },
    getQueryTransmissionStatusStock: (state) => (transmission) => {
        return state.query["transmissions"]
            .filter(t => t === transmission).length !== 0
    },
    getQueryColorStatusStock: (state) => (color) => {
        return state.query["colors"].filter(c => c === color).length !== 0
    },
    getQueryAuctionGradeStatusStock: (state) => (grade) => {
        return state.query["grades"]
            .filter(g => g === grade).length !== 0
    },
    getAllAuctionsByRegionStock: (state) => (region) => {
        return state.auctions.filter(a => {
            if (a.region === region) return a
        })
    },
    getQueryAuctionByIdStock: state => auction => {
        return state.query['auctions'].filter(a => a === auction)
    },
    getTotalLotsStock: function (state) {
        return state.totalLots
    },
    getQueryStock: state => {
        return state.query
    },
    getQueryAuctionsHasRegionStock: (state) => (region) =>  {
        let auctions = [];

        for(let auction in state.auctions){
            for(let filter in state.query['auctions']){

                if(state.auctions[auction].id === state.query['auctions'][filter]){
                    auctions.push(state.auctions[auction]);
                }
            }
        }

        let found = false;

        for(let i = 0; i < auctions.length; i++) {
            if (auctions[i].region === region) {
                found = true;
                break;
            }
        }

        return found
    },
    getSingleStockCar: (state) => {
        return state.lot
    },
    checkIfLotIsVisitedStock: (state) => (lotId) => {
        return state.isVisited.includes(lotId)
    },
    getActiveStock: (state) => {
        return state.lot.enquiry
    },
    getStockOrderColumn: (state) => {
        return state.query.order_column
    },
    getStockOrderType: (state) => {
        return state.query.order_type
    }
}

const mutations = {
    setSearchResults: (state, newValue) => {
        state.searchResults = newValue
    },
    setStockCarsOrderColumn: (state, newValue) => {
        state.query.order_column = newValue

    },
    setStockCarsOrderType: (state, newValue) => {
        state.query.order_type = newValue
    },
    setStockCarsLastPage: function (state, lastPage) {
        state.lastPage = lastPage
    },
    setTotalStockCars: function (state, totalLots) {
        state.totalLots = totalLots
    },
    setStockCarsCurrentPage: function (state, currentPage) {
        state.currentPage = currentPage
    },
    updateStockCarsPageNumber: (state, pageNumber) => {
        state.query.page = pageNumber
    },
    setStockCarAlertDetails: (state, details) => {
        state.stockCarAlertModalStatus = details.stockCarAlertModalStatus;
        state.stockCarAlertMessage = details.stockCarAlertMessage;
        state.carObj = details.carObj;
    },
    setStockCarAlertMessage: (state, message) => {
        state.stockCarAlertMessage = message
    },
    setEnquiryErrors: (state, data) => {
        state.stockCarErrorMessage = data.phone
    },
    handleQueryModelsStock: (state, value) => {
        state.query["models"] = value
    },
    mutateBrandModelsAndTypesStock: (state, data) => {
        state.models = data.models
        state.types = data.types
    },
    mutateServerModelsStock: (state, value) => {
        state.serverModels = value
    },
    setQueryCompanyIdStock: (state, companyId) => {
        state.query.brand = companyId
    },
    mutateChassisStock: (state, value) => {
        state.chassis = value
    },
    resetChassisQueryStock: (state) => {
        state.query['chassis'] = []
    },
    setChassisQueryStock: (state, chassis) => {
        state.query['chassis'] = chassis
    },
    removeModelsStock: (state) => {
        state.query['models'] = []
    },
    addModelToQueryStock: (state, model) => {
        state.query['models'].push(model)
    },
    removeModelFromQueryStock: (state, model) => {
        state.query['models'] = state.query['models'].filter(m => m !== model)
    },
    handleQueryChassisStock: (state, value) => {
        state.query["chassis"].push(value)
    },
    removeChassisFromQueryStock: (state, chassis) => {
        state.query['chassis'] = state.query['chassis'].filter(m => m !== chassis)
    },
    changeYearRangeMinStock: (state, newValue) => {
        state.query.yearMin = newValue
    },
    changeYearRangeMaxStock: (state, newValue) => {
        state.query.yearMax = newValue
    },
    changeKmRangeMinStock: (state, newValue) => {
        state.query.kmsMin = newValue
    },
    changeKmRangeMaxStock: (state, newValue) => {
        state.query.kmsMax = newValue
    },
    handleQueryLotsStock: (state, value) => {
        state.query["lots"].push(value)
    },
    removeLotFromQueryStock: (state, lots) => {
        state.query['lots'] = state.query['lots'].filter(m => m !== lots)
    },
    updateStatsStatusStock: (state, value) => {
        state.status = value
    },
    pushDateToQueryStock: (state, date) => {
        state.query['dates'].push(date)
    },
    filterDateFromQueryStock: (state, date) => {
        state.query['dates'] = state.query['dates'].filter(m => m !== date)
    },
    updatePageNumberStock: (state, pageNumber) => {
        state.query.page = pageNumber
    },
    updateStatsQueryFieldStock: (state, input) => {
        state.query[input.field] = input.value
    },
    updateStatsQueryStock: (state, query) => {
        const notAllowed = ['order_column', 'order_type', 'page', 'auctionType'];

        Object.keys(query)
            .filter(key => notAllowed.includes(key))
            .forEach(key => delete query[key])


        for (const [key, value] of Object.entries(query)) {
            state.query[key] = value
        }

    },
    updateSearchResultsLoadingStatusStock: (state, value) => {
        state.isLoading = value
    },
    updateStatsResultStock: (state, value) => {
        state.result = value
    },
    setTotalLotsStock: function (state, totalLots) {
        state.totalLots = totalLots
    },
    mutateResultOrderColumnStock: (state, newValue) => {
        state.query.order_column = newValue
    },
    setDefaultAuctionQueryStock: (state) => {
        const defaultQ = {
            brand: '',
            'models': [],
            'grades': [],
            yearMin: 1970,
            yearMax: new Date().getFullYear(),
            kmsMin: null,
            kmsMax: null,
            priceMin: null,
            priceMax: null,
            ccMin: null,
            ccMax: null,
            date: null,
            'dates': [],
            carGrade: null,
            'chassis': [],
            'transmissions': [],
            'lots': [],
            'colors': [],
            'equipment': [],
            'auctions': [],
            'regions': [],
            order_column: 'auct_date',
            order_type: 'DESC',
            page: 1,
            auctionType: 0
        }
        state.query = Object.assign({}, defaultQ)
    },
    changeAuctionsStock: (state, data) => {
        state.auctions = data
    },
    changeRegionsStock: (state, data) => {
        state.regions = data
    },
    changeCCRangeMinStock: (state, newValue) => {
        state.query.ccMin = newValue
    },
    changeCCRangeMaxStock: (state, newValue) => {
        state.query.ccMax = newValue
    },
    handleQueryTransmissionStock: (state, value) => {
        if (state.query["transmissions"].filter(t => t === value).length === 0)  {
            state.query["transmissions"].push(value)
        } else {
            state.query["transmissions"] = state.query["transmissions"].filter(t => t !== value)
        }
    },
    handleQueryColorStock: (state, value) => {
        if (state.query["colors"].filter(c => c === value).length === 0)  {
            state.query["colors"].push(value)
        } else {
            state.query["colors"] = state.query["colors"].filter(c => c !== value)
        }
    },
    handleQueryGradesStock: (state, value) => {
        if (state.query["grades"].filter(g => g === value).length === 0)  {
            state.query["grades"].push(value)
        } else {
            state.query["grades"] = state.query["grades"].filter(g => g !== value)
        }
    },
    handleAuctionsQueryStock: (state, auctions) => {
        // TODO check containers exisitngCount > newCount, existingCount == newCount, existingCoung == 0
        const existing = state.query['auctions']
        if ( existing.length === 0 ) {
            state.query['auctions'] = auctions
        } else {
            const filterExisting = existing.filter(ex => !auctions.includes(ex))
            const filterNewAuctions = auctions.filter(ex => !existing.includes(ex))
            state.query['auctions'] = filterExisting.concat(filterNewAuctions)
        }
    },
    addAuctionToQueryStock: (state, auction) => {
        state.query['auctions'].push(auction)
    },
    removeAuctionFromQueryStock: (state, auction) => {
        state.query['auctions'] = state.query['auctions'].filter(a => a !== auction)
    },
    setSingleStockCar: (state, lotData) => {
        state.lot = lotData
    },
    pushLotIdToIsVisitedStock: (state, value) => {
        state.isVisited.push(value)
    },
    setActiveLotEnquiry: (state, value) => {
        state.searchResults.data[state.activeLotKey].enquiry = value
    },
    setActiveLotKeyEnquiry: (state, value) => {
        state.activeLotKey = value
    },
    mutateStockOrderColumn: (state, newValue) => {
        state.query.order_column = newValue
    },
    mutateStockOrderType: (state, newValue) => {
        state.query.order_type = newValue
    }
}

const actions = {
    fetchStockCars: function (context) {
        context.commit('updateSearchResultsLoadingStatusStock', true)
        context.dispatch('setStatusLoading')
        context.commit('updateStockCarsPageNumber', 1)
        stockCars
            .getStockCars(context.getters.getStockCarsQuery)
            .then((response) => {
                context.commit('updateSearchResultsLoadingStatusStock', false)
                context.commit('setTotalStockCars', response.data.data.total)
                context.commit('setSearchResults', {user: response.data.user, data: response.data.data.data})
                context.commit('setStockCarsCurrentPage', 1)
                context.commit('setStockCarsLastPage', response.data.data.last_page)
                context.dispatch('setStatusLoaded')
            })
            .catch(error => console.log(error))
    },
    fetchPastResult: function (context) {
        context.commit('updateSearchResultsLoadingStatusStock', true)
        context.dispatch('setStatusLoading')
        stockCars
            .getPastResult(context.getters.getStockCarsQuery)
            .then((response) => {
                context.commit('updateSearchResultsLoadingStatusStock', false)
                context.commit('setTotalStockCars', response.data.total)
                context.commit('setSearchResults', response.data.data)
                context.commit('setStockCarsCurrentPage', response.data.current_page)
                context.commit('setStockCarsLastPage', response.data.last_page)
                context.dispatch('setStatusLoaded')
            })
            .catch(error => console.log(error))
    },
    setStockCarsNewOrderColumn: ({commit}, newValue) => {
        commit('setStockCarsOrderColumn', newValue)
    },
    setStockCarsNewOrderType: ({commit}, newValue) => {
        commit('setStockCarsOrderType', newValue)
    },
    loadStockCardMoreResults: ({dispatch, commit, getters}, newPage) => {
        commit('updateSearchResultsLoadingStatusStock', true)
        dispatch('setStatusLoading')
        commit('updateStockCarsPageNumber', newPage)

        stockCars
            .getStockCars(getters.getStockCarsQuery)
            .then((response) => {
                commit('updateSearchResultsLoadingStatusStock', false)
                commit('setTotalStockCars', response.data.data.total)
                commit('setSearchResults', {user: response.data.user, data: response.data.data.data})
                commit('setStockCarsCurrentPage', response.data.data.current_page)
                commit('setStockCarsLastPage', response.data.data.last_page)
                dispatch('setStatusLoaded')
            })
            .catch(error => console.log(error))
    },
    setStockCarsQueryPageNumber: ({commit}, value) => {
        commit('updateStockCarsPageNumber', value)
    },
    setStockCarAlertDetails: ({commit}, details) => {
        commit('setStockCarAlertDetails', details)
    },
    sendEnquiry: ({commit}, data) => {
        commit('setEnquiryErrors', {})
        commit('updateSearchResultsLoadingStatusStock', true)
        return new Promise((resolve, reject) => {
            stockCars
                .sendEnquiry(data)
                .then((response) => {
                    commit('updateSearchResultsLoadingStatusStock', false)
                    commit('setStockCarAlertMessage', response.data.success)
                    commit('setActiveLotEnquiry', ['success']);
                    resolve();
                })
                .catch((error) => {
                    console.log(error)
                    if (error.response && error.response.status === 422) {
                        reject();
                        commit('setEnquiryErrors', JSON.parse(error.response.data))
                    }
                })
        });
    },
    handleQueryModelsStock: ({commit}, value) => {
        commit('handleQueryModelsStock', value)
    },
    setModelsToDefaultStock: ({commit}) => {
        commit('mutateBrandModelsAndTypesStock', {models: [], types: []})
    },
    fetchBrandModelsByBrandIdStock: ({commit, dispatch}, brandId) => {
        dispatch('setStatusLoading')
        apiAuctions
            .getModelsByBrandId(brandId)
            .then((response) => {
                commit('mutateServerModelsStock', response.data)
                dispatch('setStatusLoaded')
            })
            .catch((error) => {
                console.log(error)
            })
    },
    changeQueryCompanyIdStock: ({commit}, value) => {
        commit('setQueryCompanyIdStock', value)
    },
    setChassisToDefaultStock: ({commit}) => {
        commit('mutateChassisStock', [])
        commit('resetChassisQueryStock')
    },
    resetChassisQueryStock: ({commit}) => {
        commit('resetChassisQueryStock')
    },
    setChassisQueryStock: ({commit}, chassis) => {
        commit('setChassisQueryStock', chassis)
    },
    removeModelsStock: ({commit}) => {
        commit('removeModelsStock')
    },
    addModelToQueryStock: ({commit}, model) => {
        commit('addModelToQueryStock', model)
    },
    fetchAllChassisByModelNameStock: ({commit}, modelName) => {
        stockCars
            .getChassisByModelNameStock(modelName)
            .then((response) => {
                commit('mutateChassisStock', response.data)
            })
            .catch((error) => {
                console.log(error)
            })
    },
    removeModelFromQueryStock: ({commit}, model) => {
        commit('removeModelFromQueryStock', model)
    },
    handleQueryChassisStock: ({commit}, value) => {
        commit('handleQueryChassisStock', value)
    },
    removeChassisFromQueryStock: ({commit}, model) => {
        commit('removeChassisFromQueryStock', model)
    },
    addNewYearRangeMinValueStock: ({commit}, value) => {
        commit('changeYearRangeMinStock', value)
    },
    addNewYearRangeMaxValueStock: ({commit}, value) => {
        commit('changeYearRangeMaxStock', value)
    },
    addNewKmRangeMinValueStock: ({commit}, value) => {
        commit('changeKmRangeMinStock', value)
    },
    addNewKmRangeMaxValueStock: ({commit}, value) => {
        commit('changeKmRangeMaxStock', value)
    },
    handleQueryLotsStock: ({commit}, value) => {
        commit('handleQueryLotsStock', value)
    },
    removeLotFromQueryStock: ({commit}, model) => {
        commit('removeLotFromQueryStock', model)
    },
    setStatsStatusStock: ({commit}, value) => {
        commit('updateStatsStatusStock', value)
    },
    addDateToQueryStock: ({commit}, date) => {
        commit('pushDateToQueryStock', date)
    },
    removeDateFromQueryStock: ({commit}, date) => {
        commit('filterDateFromQueryStock', date)
    },
    setSearchQueryPageNumberStock: ({commit}, value) => {
        commit('updatePageNumberStock', value)
    },
    setStatsQueryFieldValueStock: ({commit}, value) => {
        commit('updateStatsQueryFieldStock', value)
    },
    mergeStatsQueryWithSearchStock: ({commit}, value) => {
        commit('updateStatsQueryStock', value)
    },
    setResultOrderColumnStock: ({ commit }, newValue) => {
        commit('mutateResultOrderColumnStock', newValue)
    },
    setQueryToDefaultStock: ({commit}) => {
        commit('setDefaultAuctionQueryStock')
    },
    fetchAuctionsDataStock: ({ commit , dispatch}) => {
        dispatch('setStatusLoading')
        apiAuctions.getAuctionsData()
            .then((response) => {
                commit('changeAuctionsStock', response.data.auctions)
                commit('changeRegionsStock', response.data.regions)
                dispatch('setStatusLoaded')
            })
            .catch((error) => console.log(error))
    },
    addNewCCRangeMinValueStock: ({ commit }, value) => {
        commit('changeCCRangeMinStock', value)
    },
    addNewCCRangeMaxValueStock: ({ commit }, value) => {
        commit('changeCCRangeMaxStock', value)
    },
    handleQueryTransmissionStock: ({ commit }, value) => {
        commit('handleQueryTransmissionStock', value)
    },
    handleQueryColorStock: ({ commit }, value) => {
        commit('handleQueryColorStock', value)
    },
    handleQueryGradesStock: ({ commit }, value) => {
        commit('handleQueryGradesStock', value)
    },
    addAllAuctionsByRegionForAllDaysStock: ({ commit, getters }, region) => {
        const auctions = getters.getAllAuctionsByRegionStock(region).map(a => a.id)
        commit('handleAuctionsQueryStock', auctions)
    },
    addAuctionToQueryStock: ({ commit }, auction) => {
        commit('addAuctionToQueryStock', auction)
    },
    removeAuctionFromQueryStock: ({ commit }, auction) => {
        commit('removeAuctionFromQueryStock', auction)
    },
    fetchSingleStockCarData: ({ commit, dispatch }, lotId) => {
        dispatch('setStatusLoading')
        stockCars.getSingleStockCar(lotId)
            .then((response) => {
                commit('setSingleStockCar', response.data)
                dispatch('setStatusLoaded')
            })
            .catch(error => console.log(error))
    },
    setSingleLotData: ({ commit }, newData) => {
        commit('setSingleLot', newData)
    },
    setLotToIsVisitedStock: ({ commit }, value) => {
        commit('pushLotIdToIsVisitedStock', value)
    },
    changeActiveLotEnquiry: ({ commit }, value) => {
        commit('setActiveLotEnquiry', value)
    },
    changeSearchResultActiveLotKeyEnquiry: ({ commit }, value) => {
        commit('setActiveLotKeyEnquiry', value)
    },
    setStockOrderColumn: ({ commit }, newValue) => {
        commit('mutateStockOrderColumn', newValue)
    },
    setStockOrderType: ({ commit }, newValue) => {
        commit('mutateStockOrderType', newValue)
    }
}

export default {state, getters, mutations, actions}


// WEBPACK FOOTER //
// ./src/store/modules/stockCars.js